import { render, staticRenderFns } from "./StatusWinForm.vue?vue&type=template&id=9522c640&"
import script from "./StatusWinForm.vue?vue&type=script&lang=js&"
export * from "./StatusWinForm.vue?vue&type=script&lang=js&"
import style0 from "./StatusWinForm.vue?vue&type=style&index=0&id=9522c640&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports